import { checkResponse } from "utils";
import * as qs from "query-string";

const { axios } = window;

// 企业端：查找员工列表
export const getStaffList = params => {
  return axios.get(`/staff/list`, { params }).then(checkResponse);
};

// 交易记录列表
export const transactionList = params => {
  return axios.get(`/transaction/list`, { params }).then(checkResponse);
};

// 冻结记录列表
export const freezesList = params => {
  return axios.get(`/freezes/list`, { params }).then(checkResponse);
};

// 微信充值
export const weixinCharge = fee => {
  return axios
    .post(`/transaction/weixin/recharge?fee=${fee}`)
    .then(checkResponse);
};
// 银联充值
export const yinlianCharge = (txnAmt, companyId, frontUrl) => {
  return axios
    .get(
      `/unipay/startUnionPay?txnAmt=${txnAmt}&companyId=${companyId}&frontUrl=${frontUrl}`
    )
    .then(checkResponse);
};

// 平台微信充值
export const weixinPlatCharge = fee => {
  return axios
    .post(`/transaction/weixin/recharge/plat?fee=${fee}`)
    .then(checkResponse);
};

// 用户端：当日提现详细
export const weixinCashOutInfo = () => {
  return axios.get(`/customer/cash/out/daily/info`).then(checkResponse);
};

// 微信提现(不支持验证码)
export const weixinCashout = cash => {
  return axios.post(`/customer/cash/out?cash=${cash}`).then(checkResponse);
};

// 微信提现(支持验证码)
export const weixinCashout01 = params => {
  return axios.post(`/customer/cash/out?code=${params}`).then(checkResponse);
};

// 企业端：邀请员工
export const staffInvite = params => {
  return axios.post(`/staff/invite`, params).then(checkResponse);
};

// 用户资金
export const customerCaptial = params => {
  return axios.get(`/customer/captial`, { params }).then(checkResponse);
};

// 绑定微信
export const bindingWx = params => {
  return axios
    .get(`/customer/getBindingQrCodeUrl`, { params })
    .then(checkResponse);
};
// 监听绑定回调
export const bindgResult = params => {
  return axios
    .get(`/customer/bindingResultBySceneId`, { params })
    .then(checkResponse);
};
// 补充用户昵称和用户头像
export const completeCustomerInfo = params => {
  return axios
    .post(`/customer/completeCustomerInfo`, params)
    .then(checkResponse);
};
// 获取渠道列表
export const channelList = () => {
  return axios.get(`/transaction/channel`).then(checkResponse);
};
//  员工离职
export const staffOut = params => {
  return axios.put(`/staff/out?staffId=${params}`).then(checkResponse);
};
//  是否可以解除微信
export const checkWxOut = () => {
  return axios
    .get(`/customer/checkCanUnBindingWeixinByToken`)
    .then(checkResponse);
};
//  解除微信
export const unbindingWeixin = () => {
  return axios.post(`/customer/unbindingWeixin`).then(checkResponse);
};
//  获取企业列表
export const getCustomerList = params => {
  return axios.get(`/customer/staff`, { params }).then(checkResponse);
};
//  获取服务列表
export const getServiceList = params => {
  return axios.get(`/company/service/list`, { params }).then(checkResponse);
};
// 企业端：企业试用（追加）服务
export const getTestServiceList = params => {
  return axios
    .post(
      `/company/service/create?companyId=${params.companyId}&serviceType=${params.serviceType}`
    )
    .then(checkResponse);
};
//  用户 试用（追加）服务
export const getCustomerTestServiceList = params => {
  return axios
    .post(`/company/customer/service/create?serviceType=${params.serviceType}`)
    .then(checkResponse);
};

// 用户端：红包提现检测
export const tiXianTest = () => {
  return axios.get(`/customer/cash/check`).then(checkResponse);
};
// 企业端：设置当前企业
export const setCompanyId = params => {
  return axios
    .post(
      `/customer/current/company${
        params.token ? `?token=${params.token}` : ""
      }`,
      qs.stringify(params)
    )
    .then(checkResponse);
};
//  获取当前企业
export const getCompanyId = params => {
  return axios.get(`/customer/current/company`, { params }).then(checkResponse);
};
//  企业邀请详细
export const getInfoKy = params => {
  return axios.get(`/inviteJoin/info/key`, { params }).then(checkResponse);
};
//  用户端：引流渠道列表
export const channelListUser = params => {
  return axios.get(`/customer/channel/list`, { params }).then(checkResponse);
};
//  用户端：注册目的列表
export const purposeListUser = params => {
  return axios.get(`/customer/purpose/list`, { params }).then(checkResponse);
};
//  用户端：注册目的列表
export const purposeFinnalPut = (params, token) => {
  return axios
    .put(`/customer/purpose?token=${token}`, params)
    .then(checkResponse);
};

//  用户检测相关
//  查看检测历史
export const userTestListApi = params => {
  return axios
    .get(`/registCheck/historyCheckResult`, { params })
    .then(checkResponse);
};
// 下载模板
export const downloadModelApi = () => {
  return axios
    .get(`/registCheck/downloadTemplateXlsx`, {
      params: "",
      headers: { "Content-Type": "application/json,charset=utf-8" },
      responseType: "arraybuffer"
    })
    .then(checkResponse);
};
// 检测单个手机号注册情况
export const testPhoneApi = phoneNumber => {
  return axios
    .post(`/registCheck/checkByPhoneNumber?phoneNumber=${phoneNumber}`)
    .then(checkResponse);
};
// 通过电子表格检测注册情况
export const testExcelApi = params => {
  return axios
    .post(`/registCheck/checkByExcel`, { params })
    .then(checkResponse);
};
// 设置风格企业ID
export const assignStyleCompanyId = (id, token) => {
  return axios
    .post(
      `/customer/assignStyleCompanyId?styleCompanyId=${id}${
        token ? `&token=${token}` : ""
      }`
    )
    .then(checkResponse);
};
// 用username判断用户是否存在
export const checkExist = params => {
  return axios.get(`/customer/checkExist`, { params }).then(checkResponse);
};
// 企业端：创建企业认证
export const createCompanyIdentify = (params, token) => {
  return axios
    .post(`/companyIdentify/create?token=${token}`, params)
    .then(checkResponse);
};
// 企业端：修改企业认证
export const updateCompanyIdentify = (identifyId, params, token) => {
  return axios
    .put(
      `/companyIdentify/update?identifyId=${identifyId}&token=${token}`,
      params
    )
    .then(checkResponse);
};
// 企业端：企业认证详细
export const infoCompanyIdentify = params => {
  return axios
    .get(`/companyIdentify/info/company`, { params })
    .then(checkResponse);
};
// 用户端：创建个人认证
export const createCustomerIdentify = (params, token) => {
  return axios
    .post(`/customerIdentify/create?token=${token}`, params)
    .then(checkResponse);
};
// 用户端：修改个人认证
export const updateCustomerIdentify = (identifyId, params, token) => {
  return axios
    .put(
      `/customerIdentify/update?identifyId=${identifyId}&token=${token}`,
      params
    )
    .then(checkResponse);
};
// 用户端：个人认证详细
export const infoCustomerIdentify = params => {
  return axios
    .get(`/customerIdentify/info/customer`, { params })
    .then(checkResponse);
};
// 用来下载隐秘文件，返回文件
export const downloadFileSecret = params => {
  return axios
    .get(`/fileStorage/downloadFileSecret`, { params })
    .then(checkResponse);
};

// 搜索访问员
export const searchVisitors = params => {
  return axios
    .get(`/interviewer/searchInterviewers`, { params })
    .then(checkResponse);
};
// 性别选项
export const visitorGenderSel = () => {
  return axios.get(`/interviewer/genderOptions`).then(checkResponse);
};
// 学历选项
export const visitorEduSel = () => {
  return axios.get(`/interviewer/educationOptions`).then(checkResponse);
};
// 行业选项
export const visitorIndustrieSel = () => {
  return axios.get(`/interviewer/industrieOptions`).then(checkResponse);
};
// 年龄选项
export const visitorAgeSel = () => {
  return axios.get(`/interviewer/ageOptions`).then(checkResponse);
};
// 添加访问员
export const batchInsertInterviewer = params => {
  return axios
    .post(`/interviewer/batchInsertInterviewer`, [params])
    .then(checkResponse);
};
// 更新或者修改访问员
export const updateInterviewer = params => {
  return axios
    .post(`/interviewer/updateInterviewer`, params)
    .then(checkResponse);
};

// 通过电子表格导入样本
export const leadInExcel = params => {
  return axios
    .post(`/interviewer/updateInterviewerByXlsx`, { params })
    .then(checkResponse);
};
// 导出访问员电子表格
export const exportExcel = params => {
  return axios
    .get(`/interviewer/exportExcel`, {
      params,
      headers: { "Content-Type": "application/json,charset=utf-8" },
      responseType: "arraybuffer"
    })
    .then(checkResponse);
};
// 删除访问员
export const deleteVisitor = id => {
  return axios
    .delete(`/interviewer/deleteInterviewer?id=${id}`)
    .then(checkResponse);
};
// 用来检测检查员是否已经存在
export const checkInterviewerExist = params => {
  return axios
    .get(`/interviewer/checkInterviewerExist`, { params })
    .then(checkResponse);
};
// 问卷吧批量邀请注册短信
export const inviteRegisterNote = (companyId, params) => {
  return axios
    .post(`/serviceMessage/invite?service=0&companyId=${companyId}`, params)
    .then(checkResponse);
};

// 访问员导入模板
export const importFormwork = () => {
  return axios.get(`/interviewer/template.xlsx`).then(checkResponse);
};

// 将检查员标记为已经邀请，返回值就是访问员ID本身
export const checkMarksInvates = interviewerId => {
  return axios
    .post(`/interviewer/interviewerInvited?interviewerId=${interviewerId}`)
    .then(checkResponse);
};

/**
 * 银联提现相关
 */
// 用户端：创建提现申请
export const createYinLianTixian = (code, params) => {
  return axios
    .post(`/unipayOut/create?code=${code}`, params)
    .then(checkResponse);
};
// 用户端：银行账户列表
export const bankAccountListApi = () => {
  return axios.get(`/bankCard/list`).then(checkResponse);
};
// 用户端：银行账户详细
export const bankAccountInfoApi = bankId => {
  return axios.get(`/bankCard/info?cardId=${bankId}`).then(checkResponse);
};
// 用户端：创建银行账户
export const createbankAccountApi = params => {
  return axios.post(`/bankCard/create`, params).then(checkResponse);
};
// 用户端：删除银行账户
export const deleteBankAccountApi = bankId => {
  return axios.delete(`/bankCard/delete?cardId=${bankId}`).then(checkResponse);
};
// 用户端：当月银行卡提现次数
export const monthBankCardCountApi = () => {
  return axios.get(`/unipayOut/time`).then(checkResponse);
};
// 用户端/企业端：合作代理商合作列表
export const cooperateAgentList = params => {
  return axios.get(`/cooperateAgent/list`, { params }).then(checkResponse);
};
// 用户端/企业端：合作代理商合作导出
export const cooperateAgentExport = params => {
  return axios.get(`/cooperateAgent/export`, { params }).then(checkResponse);
};
// 用户端：获取访问员认证信息
export const getVisitorCertifyInfoApi = token => {
  return axios
    .get(`/customerIdentify/interviewer?token=${token}`)
    .then(checkResponse);
};
// 用户端：访问员认证
export const visitorCertiftApi = (token, params) => {
  return axios
    .post(`/customerIdentify/interviewer?token=${token}`, params)
    .then(checkResponse);
};
// 用户端：短信钱包详细
export const userduanxinInfoApi = () => {
  return axios
    .get(`/captialMessage/info/company?companyId=0`)
    .then(checkResponse);
};
// 用户端：购入短信
export const userBuyDuanxinApi = total => {
  return axios
    .post(`/captialMessage/purchase?companyId=0&total=${total}`)
    .then(checkResponse);
};
// 平台端：通用Apk文件配置列表
export const getGeneralAppList = () => {
  return axios.get(`/installFile/default/list`).then(checkResponse);
};
// 平台端：创建通用app文件配置
export const addGeneralApp = params => {
  return axios.post(`/installFile/create/default`, params).then(checkResponse);
};

// 平台端：通用Apk文件配置列表
export const getMyPayPlatform = params => {
  return axios.get(`/company/pay/platform`, { params }).then(checkResponse);
};
